import React from "react";
import Table from "../components/Table";
import { Link } from "react-router-dom";
import HttpDataSource from "../api/HttpDataSource";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Helmet } from "react-helmet";

class OffresGroupes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      OffresGroupes: [],
      originalOffresGroupes: [],
      searchOffresGroupesTerm: "",
      appliedSearch: "",
      page: 1,
      pageSize: 50,
      totalCount: 0
    };
  }

  async fetchPage(page) {
    const userGroup =
      this.props.userGroup || window.localStorage.getItem("userGroup");
    const idPublisher =
      this.props.idPublisher || window.localStorage.getItem("idPublisher");

    const data = await HttpDataSource.getOffresGroupesData(
      userGroup,
      idPublisher,
      page,
      this.state.pageSize,
      this.state.appliedSearch
    );

    let offres = data.result || [];

    this.setState({
      OffresGroupes: offres,
      originalOffresGroupes: offres,
      page,
      totalCount: data.totalCount || 0
    });
  }

  handlePageChange = (page) => {
    this.setState({ isLoading: true }, () => {
      this.fetchPage(page).then(() => {
        this.setState({ isLoading: false });
        window && window.scroll(0, 0);
      });
    });
  };

  async componentDidMount() {
    window && window.scroll(0, 0);
    await this.fetchPage(1);
    this.setState({ isLoading: false });
  }
  onChange = (e) => {
    const term = e.target.value;
    this.setState({ searchOffresGroupesTerm: term });
    if (term === "" && this.state.appliedSearch) {
      this.setState({ appliedSearch: "", isLoading: true }, () => {
        this.fetchPage(1).then(() => this.setState({ isLoading: false }));
      });
    }
  };

  handleSearchKey = (e) => {
    if (e.key === "Enter") {
      const term = e.target.value.trim();
      this.setState({ appliedSearch: term, isLoading: true }, () => {
        this.fetchPage(1).then(() => {
          this.setState({ isLoading: false });
        });
      });
    }
  };

  render() {
    const { t } = this.props;
    this.columns = [
      {
        dataField: "identifiant",
        text: t("Identifiant"),
        sort: this.props.boardTable ? false : true,
        classes:
          "px-5 py-4 text-center whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-black",
        headerClasses: "w-3/12 text-donaPurple font-bold whitespace-normal",
        headerAttrs: { scope: "col", tabIndex: this.props.boardTable ? -1 : 0 }
      },
      {
        dataField: "titre",
        text: t("Titre"),
        sort: this.props.boardTable ? false : true,
        classes:
          "px-5 py-4 text-left whitespace-normal border-b border-gray-200 text-md leading-5 font-bold text-donaPurple underline",
        headerClasses: "w-5/12 text-donaPurple font-bold whitespace-normal",
        headerAttrs: { scope: "col", tabIndex: this.props.boardTable ? -1 : 0 },
        attrs: { role: "rowheader", scope: "row" },
        formatter: (cell, row) => (
          <Link to={`/offres-groupes-details/${row.id_combo}`}>{row.titre}</Link>
        )
      },
      {
        dataField: "maison_edition",
        text: t(" Maison d'édition "),
        classes:
          "px-5 py-4 text-center border-b border-gray-200 text-md leading-5 text-black whitespace-normal",
        headerClasses: "w-4/12 text-donaPurple font-bold whitespace-normal",
        headerAttrs: { scope: "col", tabIndex: "-1" },
        formatter: (cell, row) => (
          <span>{`${row.maison_edition.nom}  ${
            row.maison_edition.prenom && row.maison_edition.prenom
              ? row.maison_edition.prenom
              : ""
          }`}</span>
        )
      }
    ];
    const CaptionElements = (
      <div className="lg:flex  justify-between flex-wrap-6 bg-donaPurple p-2 border border-donaPurple rounded">
        <div className="flex lg:my-auto my-2">
          <h1 className="text-white font-bold">
            {t("Liste des offres groupées")}
          </h1>
          <div className="text-white ml-1" aria-live="polite">
            {this.state.isLoading === false &&
              "(" +
                this.state.totalCount +
                " " +
                (this.state.totalCount > 1
                  ? t("enregistrements")
                  : t("enregistrement")) +
                ")"}
          </div>
        </div>
        <div className="lg:mx-auto lg:text-center text-left my-2">
          <Link
            to={"/offres-groupes-details"}
            className="donaButton button-color--invertTurquoisepale my-0"
            style={{ marginTop: "0", marginBottom: "0" }}
          >
            {t("Créer une offre groupée")}
          </Link>
        </div>
        <div className="relative lg:my-auto text-left">
          <FontAwesomeIcon
            icon={faSearch}
            className="absolute pointer-events-none  inset-y-0 ml-3 mt-3 flex items-center"
          />
          <input
            type="search"
            onKeyDown={this.handleSearchKey}
            onChange={this.onChange}
            value={this.state.searchOffresGroupesTerm}
            className="bg-white shadow appearance-none border rounded py-2 px-3 text-gray-700 pl-10 leading-tight focus:outline-none focus:shadow-outline"
            placeholder={t("Recherche sur table")}
            aria-label={t("Rechercher dans le tableau")}
          />
        </div>
      </div>
    );
    return (
      <>
        {!this.props.boardTable && (
          <Helmet>
            <title>{t("Offres Groupées")}</title>
            <meta name="description" content={t("Offres Groupées")} />
          </Helmet>
        )}
        <Table
          keyField="id_combo"
          loading={this.state.isLoading}
          showMore={false}
          boardTable={false}
          data={this.state.OffresGroupes}
          noDataMessage={t("Pas d'offres groupés Disponible")}
          caption={CaptionElements}
          columns={this.columns}
          classes="my-5"
          t={t}
          page={this.state.page}
          pageSize={this.state.pageSize}
          totalCount={this.state.totalCount}
          onPageChange={this.handlePageChange}
        />
      </>
    );
  }
}
export default OffresGroupes;
